import classNames from 'classnames';
import Text from '@hiredigital/ui/Text/Text';
// import Img from '@components/Img';
import { Section, SectionContainer } from '@components/Section';
import Styles from './FunnelSection.module.scss';

const FunnelSection = ({ className, anchor = 'funnel-section', section }) => {
  return (
    <SectionContainer anchor={anchor}>
      <Section
        className={classNames(Styles.section, className)}
        title={section.title}
        subtitle={section.subtitle}>
        <div className={Styles.container}>
          {section.cards.map((step, index) => {
            return (
              <div key={index} className={Styles.row}>
                <div className={classNames(Styles.numberCell, Styles[`number${index + 1}`])}>
                  {index + 1}
                </div>
                <div className={Styles.textCell}>
                  <div className={Styles.title}>{step.title}</div>
                  <div
                    className={Styles.description}
                    dangerouslySetInnerHTML={{ __html: step?.description?.html }}></div>
                </div>
              </div>
            );
          })}
        </div>
      </Section>
    </SectionContainer>
  );
};

export default FunnelSection;
